import { useAuth } from "./auth"
import { Dashboard } from "./components/Dashboard"
import { JoinPage } from "./pages/Join"
import { PairPage } from "./pages/Pair"
import { SignInScreen } from "./pages/SignIn"

export function App() {
	const auth = useAuth()
	const path = location.pathname
	if (auth.status === "loading")
		return (
			<div className="page">
				<div style={{ width: 160 }} className="loading-bar" />
			</div>
		)
	if (auth.status === "signed-out")
		return (
			<SignInScreen
				note={
					path === "/pair"
						? "Sign in to approve the device that is pairing."
						: path === "/join"
							? "Sign in to accept your invitation."
							: undefined
				}
			/>
		)
	if (path === "/pair") return <PairPage />
	if (path === "/join") return <JoinPage />
	return <Dashboard />
}
